import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ConnectivityService implements OnDestroy {
    protected destroy: Subject<boolean> = new Subject<boolean>();
    private readonly offlineSubject = new BehaviorSubject<boolean>(
        typeof navigator !== 'undefined' && !navigator.onLine
    );
    public readonly offline$: Observable<boolean> = this.offlineSubject.asObservable();

    constructor(protected zone: NgZone) {
        fromEvent(window, 'offline')
            .pipe(takeUntil(this.destroy))
            .subscribe(() => this.markOffline());

        fromEvent(window, 'online')
            .pipe(debounceTime(300), takeUntil(this.destroy))
            .subscribe(() => this.markOnline());
    }

    public isOffline(): boolean {
        return this.offlineSubject.getValue();
    }

    public markOffline(): void {
        if (this.offlineSubject.getValue()) {
            return;
        }
        this.zone.run(() => this.offlineSubject.next(true));
    }

    public markOnline(): void {
        if (!this.offlineSubject.getValue()) {
            return;
        }
        this.zone.run(() => this.offlineSubject.next(false));
    }

    public ngOnDestroy(): void {
        this.destroy.next(true);
        this.destroy.complete();
        this.offlineSubject.complete();
    }
}
